import { Application } from 'src/app/account/services/application.service'
import { ApplicationRecoveryPointDto, RetentionSettingsDto } from 'src/app/services/dtos'
import { buildMockApplication } from './showcase-mock-core'

// Apps the mock retained recovery points belong to. Deliberately NOT seeded
// into the application cache — the retention component resolves names through
// a scoped loadApplication$ patch, and seeding would add stray apps to every
// dialog's candidate list.
export const RETENTION_MOCK_APPS: ReadonlyArray<{ applicationId: string; name: string }> = [
  { applicationId: 'MOCK-TEST-retention-payments', name: 'MOCK-TEST Payments API' },
  { applicationId: 'MOCK-TEST-retention-warehouse', name: 'MOCK-TEST Data warehouse' },
  { applicationId: 'MOCK-TEST-retention-portal', name: 'MOCK-TEST Customer portal' },
]

export function buildMockRetentionApplications(): Map<string, Application> {
  return new Map<string, Application>(
    RETENTION_MOCK_APPS.map((app) => [app.applicationId, buildMockApplication(app)] as [string, Application])
  )
}

export function buildMockRetainedRecoveryPoints(): ApplicationRecoveryPointDto[] {
  const now = Date.now()
  const HOUR_MS = 60 * 60 * 1000
  return RETENTION_MOCK_APPS.flatMap((app, appIndex) =>
    Array.from({ length: 4 }, (_unused, rpIndex) => {
      const timestamp = new Date(now - (appIndex * 4 + rpIndex + 1) * 6 * HOUR_MS)
      return {
        applicationId: app.applicationId,
        applicationName: app.name,
        recoveryPointId: `${app.applicationId}-rp-${rpIndex + 1}`,
        timestamp,
        availableAt: timestamp,
        protected: true,
      } as ApplicationRecoveryPointDto
    })
  )
}

export function buildMockRetentionSettings(): RetentionSettingsDto {
  return { recentRetained: 24, daysRetained: 7, weeksRetained: 4, monthsRetained: 6, quartersRetained: 4 }
}

// -------------------------------------------------------------------------
// Network sandbox scenario matrix (ARP-7142)
//
// The sandbox UI in launch-test-dialog and application-test-config-dialog
// branches on three customer-configuration axes: cloud (AWS/Azure), the
// resource types present in the recovery point (Internet Gateway / Security
// Group for AWS, Virtual Network for Azure), and account capability flags.
// Each scenario below fixes those axes so the test page can open the dialog
// in one specific rendered state. `disabledCapabilities` lists capabilities
// to turn OFF for the scenario (all are ON by default in the modals showcase);
// `siblingFailoverTest` seeds that many extra in-test apps sharing the anchor's
// region, which drives sandboxFrozen (launch-test) or the "also applies to"
// notice (sandbox settings).
// -------------------------------------------------------------------------
